import { Getter } from "vuex";
import { IState } from './state';

const openPage: Getter<IState, IState> = state => {
	return state.pages.find(page => page.open)
}

export default {
	openPage
}
